"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.BADGES_ENDPOINT = {
    getListBadgeTechnologies: '/badges/{{version}}/badge-technologies',
    postCustomBadgeToUser: '/badges/{{version}}/users/{{userUuid}}/badge-technologies/{{badgeTechnologyTuid}}',
    postUbeeqoBadge: '/badges/{{version}}/users/{{userUuid}}/badges/request',
};
